import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
	XThemeModal,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
	List,
	Radio,
	Checkbox,
	Modal,
} from 'antd';
import {
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
} from '../../VoiceAssistanceStyle';
import {
	CalendarOutlined,
	PlusCircleOutlined,
	PlusOutlined,
} from '@ant-design/icons';

const { TextArea } = Input;

const VAMissingFields = (props) => {
	const {
		missingFields = [],
		missingFieldInstructions = [],
		missingFieldTitle = 'Denial Procedure',
		onSubmit,
		handleAddOption,
		missingFieldsForm,
		caseInfo = { patient_name: '', case_id: '', mrn: '' },
	} = props;

	return (
		<>
			<XThemeVSSetViewPort>
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								<span>
									Provide us with the below details for
									completing the analysis
								</span>
								<br />
								{missingFieldTitle}
							</XThemeVoiceAssTitle>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									<Row
										gutter={[15, 15]}
										className="align-items-center"
									>
										<Col xs={24} sm={12} lg={12}>
											<div className="cardTitle">
												{caseInfo.patient_name}
												{caseInfo.case_id && (
													<span className="details1">
														{caseInfo.case_id}
													</span>
												)}
											</div>
											<div className="cardTitle">
												<span className="details2">
													{caseInfo.mrn}
												</span>
											</div>
										</Col>
									</Row>
								</div>
								<Row gutter={[15, 15]}>
									<Col xs={24}>
										<div className="instructionsTitle">
											Instructions
										</div>
									</Col>
								</Row>
								<div className="hasPadding py-3">
									<Row>
										<Col xs={24}>
											<ul className="listData1">
												{missingFieldInstructions.length >
												0 ? (
													missingFieldInstructions.map(
														(
															instruction,
															index,
														) => (
															<li key={index}>
																{instruction}
															</li>
														),
													)
												) : (
													<li>
														Please provide the
														required information
													</li>
												)}
											</ul>
										</Col>
									</Row>
								</div>
								<Row gutter={[15, 15]}>
									<Col xs={24}>
										<div className="instructionsTitle">
											Select all treatments/procedures for
											which coverage needs to be checked
										</div>
									</Col>
								</Row>
								<div className="hasPadding pt-3">
									<Form
										form={missingFieldsForm}
										onFinish={(values) => {
											if (onSubmit) {
												onSubmit(values);
											}
										}}
									>
										<Row>
											<Col xs={24}>
												{missingFields.length > 0 ? (
													missingFields.map(
														(field, index) => {
															if (
																field.type ===
																'checkbox'
															) {
																return (
																	<div
																		key={
																			index
																		}
																		className="mb-3"
																	>
																		<Form.Item
																			name={
																				field.name
																			}
																			rules={[
																				field.required && {
																					required: true,
																					message:
																						field.required_error_message ||
																						'This field is required',
																				},
																			]}
																		>
																			<Checkbox.Group
																				style={{
																					display:
																						'flex',
																					flexDirection:
																						'column',
																				}}
																			>
																				{field.options.map(
																					(
																						option,
																						optIndex,
																					) => (
																						<div
																							key={
																								optIndex
																							}
																							className="mb-2"
																						>
																							<XThemeVACheckbox
																								value={
																									option.value
																								}
																							>
																								{
																									option.label
																								}
																							</XThemeVACheckbox>
																						</div>
																					),
																				)}
																				<Button
																					type="link"
																					icon={
																						<PlusOutlined />
																					}
																					onClick={() =>
																						handleAddOption(
																							index,
																						)
																					}
																					className="add-option-btn"
																				>
																					Add
																					Option
																				</Button>
																			</Checkbox.Group>
																		</Form.Item>
																	</div>
																);
															} else if (
																field.type ===
																'radio'
															) {
																return (
																	<div
																		key={
																			index
																		}
																		className="mb-3"
																	>
																		<Form.Item
																			name={
																				field.name
																			}
																			rules={[
																				field.required && {
																					required: true,
																					message:
																						field.required_error_message ||
																						'This field is required',
																				},
																			]}
																		>
																			<Radio.Group
																				style={{
																					display:
																						'flex',
																					flexDirection:
																						'column',
																				}}
																			>
																				{field.options.map(
																					(
																						option,
																						optIndex,
																					) => (
																						<div
																							key={
																								optIndex
																							}
																							className="mb-2"
																						>
																							<Radio
																								value={
																									option.value
																								}
																							>
																								{
																									option.label
																								}
																							</Radio>
																						</div>
																					),
																				)}
																			</Radio.Group>
																		</Form.Item>
																	</div>
																);
															} else if (
																field.type ===
																'textarea'
															) {
																return (
																	<div
																		key={
																			index
																		}
																		className="mb-3"
																	>
																		<Form.Item
																			name={
																				field.name
																			}
																			rules={[
																				field.required && {
																					required: true,
																					message:
																						field.required_error_message ||
																						'This field is required',
																				},
																				field.regex && {
																					validator:
																						(
																							rule,
																							value,
																						) => {
																							let regex =
																								new RegExp(
																									field.regex.slice(
																										1,
																										-1,
																									),
																								);
																							if (
																								!regex.test(
																									value,
																								)
																							)
																								return Promise.reject(
																									new Error(
																										field.regex_error_message ||
																											'Invalid format',
																									),
																								);
																							return Promise.resolve();
																						},
																				},
																			]}
																		>
																			<TextArea
																				rows={
																					3
																				}
																				placeholder="Enter details"
																				showCount
																			/>
																		</Form.Item>
																	</div>
																);
															} else if (
																field.type ===
																'input'
															) {
																return (
																	<div
																		key={
																			index
																		}
																		className="mb-3"
																	>
																		<Form.Item
																			name={
																				field.name
																			}
																			rules={[
																				field.required && {
																					required: true,
																					message:
																						field.required_error_message ||
																						'This field is required',
																				},
																				field.regex && {
																					validator:
																						(
																							rule,
																							value,
																						) => {
																							let regex =
																								new RegExp(
																									field.regex.slice(
																										1,
																										-1,
																									),
																								);
																							if (
																								!regex.test(
																									value,
																								)
																							)
																								return Promise.reject(
																									new Error(
																										field.regex_error_message ||
																											'Invalid format',
																									),
																								);
																							return Promise.resolve();
																						},
																				},
																			]}
																		>
																			<Input placeholder="Enter details" />
																		</Form.Item>
																	</div>
																);
															}
															return null;
														},
													)
												) : (
													<div>
														No fields to display
													</div>
												)}
											</Col>
										</Row>
										<Row className="mt-4">
											<Col xs={24}>
												<XThemeVASubmitBTN
													size="large"
													htmlType="submit"
												>
													Submit
												</XThemeVASubmitBTN>
											</Col>
										</Row>
									</Form>
								</div>
							</XThemeVoiceAssTableCard>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VAMissingFields;
